import React from 'react';
export function ComparisonTable() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-slate-100 py-12 md:py-20 px-4" data-id="element-70">
      <div className="max-w-5xl mx-auto" data-id="element-71">
        <div className="text-center mb-10" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2" data-id="element-73">
            📊 Compará los niveles
          </h2>
          <p className="text-xl text-brand-blue font-medium mb-2" data-id="element-74">
            ¿Qué incluye cada nivel?
          </p>
          <p className="text-slate-500" data-id="element-75">
            Los tres arrancan con los 6 Tomos y 6 Bonos. Elegí hasta dónde
            querés llegar.
          </p>
        </div>

        <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-slate-200 mb-10" data-id="element-76">
          <table className="w-full min-w-[800px] text-left border-collapse" data-id="element-77">
            <thead className="bg-slate-50 sticky top-0 z-10" data-id="element-78">
              <tr data-id="element-79">
                <th className="p-4 border-b border-r border-slate-200 font-bold text-slate-700 w-1/3" data-id="element-80">
                  Incluye
                </th>
                <th className="p-4 border-b border-r border-slate-200 font-bold text-slate-800 text-center w-1/6" data-id="element-81">
                  ✅ Médico en Proceso™
                </th>
                <th className="p-4 border-b border-r border-slate-200 font-bold text-brand-blue text-center w-1/6" data-id="element-82">
                  ⭐ Carrera Organizada™
                </th>
                <th className="p-4 border-b border-slate-200 font-bold text-brand-amber text-center w-1/6" data-id="element-83">
                  🏆 Gestión Académica™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-84">
              <tr className="border-b border-slate-100 hover:bg-slate-50" data-id="element-85">
                <td className="p-4 border-r border-slate-100 text-slate-700" data-id="element-86">
                  6 Tomos de Medicina completos
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-green-500 font-bold" data-id="element-87">
                  ✓
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-green-500 font-bold" data-id="element-88">
                  ✓
                </td>
                <td className="p-4 text-center text-green-500 font-bold" data-id="element-89">✓</td>
              </tr>
              <tr className="border-b border-slate-100 bg-slate-50/50 hover:bg-slate-50" data-id="element-90">
                <td className="p-4 border-r border-slate-100 text-slate-700" data-id="element-91">
                  6 Bonos estratégicos
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-green-500 font-bold" data-id="element-92">
                  ✓
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-green-500 font-bold" data-id="element-93">
                  ✓
                </td>
                <td className="p-4 text-center text-green-500 font-bold" data-id="element-94">✓</td>
              </tr>
              <tr className="border-b border-slate-100 hover:bg-slate-50" data-id="element-95">
                <td className="p-4 border-r border-slate-100 text-slate-700" data-id="element-96">
                  Tomo Guardia y Emergencias
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-slate-300" data-id="element-97">
                  —
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-green-500 font-bold" data-id="element-98">
                  ✓
                </td>
                <td className="p-4 text-center text-green-500 font-bold" data-id="element-99">✓</td>
              </tr>
              <tr className="border-b border-slate-100 bg-slate-50/50 hover:bg-slate-50" data-id="element-100">
                <td className="p-4 border-r border-slate-100 text-slate-700" data-id="element-101">
                  Tomo Medicina Interna para el Examen
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-slate-300" data-id="element-102">
                  —
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-green-500 font-bold" data-id="element-103">
                  ✓
                </td>
                <td className="p-4 text-center text-green-500 font-bold" data-id="element-104">✓</td>
              </tr>
              <tr className="border-b border-slate-100 hover:bg-slate-50" data-id="element-105">
                <td className="p-4 border-r border-slate-100 text-slate-700" data-id="element-106">
                  7 Editables premium
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-slate-300" data-id="element-107">
                  —
                </td>
                <td className="p-4 border-r border-slate-100 text-center text-slate-300" data-id="element-108">
                  —
                </td>
                <td className="p-4 text-center text-green-500 font-bold" data-id="element-109">✓</td>
              </tr>
              <tr className="bg-slate-50" data-id="element-110">
                <td className="p-4 border-r border-slate-200 font-bold text-slate-800" data-id="element-111">
                  Precio
                </td>
                <td className="p-4 border-r border-slate-200 text-center" data-id="element-112">
                  <div className="text-xs text-slate-400 line-through" data-id="element-113">
                    $58.990
                  </div>
                  <div className="font-bold text-green-600" data-id="element-114">$19.990</div>
                </td>
                <td className="p-4 border-r border-slate-200 text-center" data-id="element-115">
                  <div className="text-xs text-slate-400 line-through" data-id="element-116">
                    $102.990
                  </div>
                  <div className="font-bold text-green-600" data-id="element-117">$27.990</div>
                </td>
                <td className="p-4 text-center" data-id="element-118">
                  <div className="text-xs text-slate-400 line-through" data-id="element-119">
                    $149.990
                  </div>
                  <div className="font-bold text-green-600" data-id="element-120">$32.990</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-xl mx-auto" data-id="element-121">
          <button onClick={scrollToPricing} className="w-full bg-brand-amber hover:bg-amber-600 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-transform hover:scale-105 active:scale-95 min-h-[56px] mb-4" data-id="element-122">
            → ELEGIR MI NIVEL AHORA
          </button>
          <p className="text-sm text-slate-500 font-medium" data-id="element-123">
            Garantía de 7 días · Acceso inmediato · 100% digital
          </p>
        </div>
      </div>
    </section>;
}